module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<label for="id_filter">Filter:</label>\n<input id="id_filter" class="filter-box textfield" type="text" />\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./forms/filter/template.html
// module id = 225
// module chunks = 0